/* eslint-disable @typescript-eslint/no-explicit-any */

import { tokenStorage } from 'utils';
import { parseApiError } from 'utils/parseApiError';

export const backendHost = process.env.REACT_APP_BACKEND_HOST;
// Хост (домен) для WebSocket/Pusher, без /api
export const wsHost = process.env.REACT_APP_WS_HOST;

console.log(backendHost, wsHost);

// Типы
type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface ApiError extends Error {
  status: number;
  data?: any;
}

// Флаг, чтобы не запустить редирект дважды при параллельных 401-ответах.
let unauthorizedHandled = false;

// Сессия истекла: чистим авторизационные данные и выкидываем на форму логина
// с сообщением. Используем window.location, чтобы полностью сбросить состояние
// приложения (Redux store) и не оставить пользователя в «полуавторизованном» виде.
function handleUnauthorized(): void {
  if (unauthorizedHandled) return;
  unauthorizedHandled = true;

  tokenStorage.remove();
  try {
    localStorage.removeItem('selected_role_id');
    localStorage.removeItem('current_project_id');
  } catch {
    /* ignore */
  }
  window.location.href = '/login?reason=session_expired';
}

export default async function apiReq<T = any>(
  path: string | null = null,
  method: HttpMethod = 'GET',
  body?: any,
  isFormData?: boolean
): Promise<T | undefined> {
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
  };

  if (isFormData) {
    delete headers['Content-Type'];
  }

  const token = tokenStorage.get();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${backendHost}/${path}`, {
    method,
    headers,
    redirect: 'manual',
    body: body ? (isFormData ? body : JSON.stringify(body)) : null,
  });

  // console.log('got res: ', res);
  if (res.type === 'opaqueredirect') {
    // console.log('got res: ', res.headers);
    // console.log('got Location: ', res.headers.get('Location'));
    window.location.href = res.url || '';
    return undefined;
  }

  const json = await res.json().catch(() => null);

  if (!res.ok) {
    if (res.status === 401) {
      // На эндпоинте логина 401 = неверные креды, а не истёкшая сессия.
      // Так же не редиректим, если пользователь уже на странице логина.
      const isLoginRequest = path === 'auth/login';
      const alreadyOnLoginPage =
        typeof window !== 'undefined' && window.location.pathname === '/login';

      if (!isLoginRequest && !alreadyOnLoginPage) {
        handleUnauthorized();
        // Возвращаем never-resolving промис, чтобы вызывающий код не отработал
        // .then с пустыми данными до того, как сработает редирект.
        return new Promise<never>(() => undefined);
      }

      const { generalMessage } = parseApiError(json);
      const error = new Error(generalMessage || 'Не авторизован') as ApiError;
      error.status = 401;
      error.data = json;
      throw error;
    }
    const { generalMessage } = parseApiError(json);
    const error = new Error(generalMessage || res.statusText || 'Ошибка запроса') as ApiError;
    error.status = res.status;
    error.data = json;
    throw error;
  }

  return json;
}
